/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { React, useContext, useEffect, useState } from 'react';
import App from '../../layout/App';
import {
  FormContent, Container,
  Box, TitleFieldForm, Select,
  Option,
  Message, Madatory, LabelSelect,
  TextLabel,
  Label
} from '../../styles/styles'
import { useNavigate } from 'react-router';
import InputResponsive1 from '../../Components/InputResponsive1';
import Checkbox from '../../Components/checkbox';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import api from '../../utils/api';
import Loading from '../../Components/Loading'
import MessagePopUp from '../../Components/messagePopUp';
import { resetValues } from '../../utils/functions';
import InfoForm from '../../Components/infoForm'
import ButtonFormFooter from '../../Components/buttonFormFooter';
import { MessageContext } from '../../context/message';
import { renderSelectMulti, validationForm } from '../../utils/class/validationClass';
import { turmaJson } from '../../utils/class/classObject';
import { maskHour } from '../../utils/mask';
import { aggregtateList } from '../../utils/class/aggregrate';
import { stageList, renderStage } from '../../utils/class/stage';
import { areaCourseTeachList } from '../../utils/class/areaCourseTeach';
import { useIndexedLabels } from '../../utils/useIndexedLabels';



function Cadastro() {
  const {
    getTitleIndex,
    getIndexByLabel,
  } = useIndexedLabels();

  const [removeLoading, setRemoveLoading] = useState(false)

  const navigation = useNavigate()
  const [complementaryActivityList, setComplementaryList] = useState([])
  const { setErrorMessage } = useContext(MessageContext);
  const [classRoom, setClassRoom] = useState(turmaJson)
  const [messageRequired, setMessageRequired] = useState([])
  const [stageListVisible, setStageListVisible] = useState([])
  const [courseTechList, setCourseTechList] = useState([])
  const [courseTechListFiltered, setCourseTechListFiltered] = useState([])
  const [areaCourse, setAreaCourse] = useState(0)

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(validationForm),
    mode: 'onChange'
  });

  const onSubmit = async (data) => {
    let inep = sessionStorage.getItem('inep');
    setRemoveLoading(false)
    const dados = {
      ...classRoom,
      inepRelation: inep,
      wasChanged: true,
    };


    setTimeout(function () {
      api.put('/class/', dados).then((response) => {
        setRemoveLoading(true)
        setErrorMessage([{ message: "turma atualizada com sucesso", ok: true }])
        sessionStorage.removeItem('TurmaEditar')
        navigation('/turma/pesquisar')
      }).catch((erro) => {
        setRemoveLoading(true)
        setErrorMessage([{ message: "Erro ao atualizar turma", ok: false }])
      })
    }, 1000);
  };

  useEffect(() => {
    let turma = sessionStorage.getItem('TurmaSelecionada')
    api.get("/class/" + turma).then((response) => {
      let data = response.data
      setClassRoom(data)
      setValue(data)
    }).catch((err) => {
      setErrorMessage([{ message: "Erro ao buscar turma", ok: false }])
    })
    api.get("/resource/complementar-activity/list").then((response) => {
      setComplementaryList(response.data)
    }).catch(() => {

    })
    api.get("/resource/professional-course/list").then((response) => {
      setCourseTechList(response.data)
    }).catch(() => {

    })
    setRemoveLoading(true)
  }, [])

  useEffect(() => {
    const auxAreaCourse = courseTechList
      .map(curso => ({
        ...curso,
        eixoCode: Math.floor(curso.code / 1000)
      }))
      .filter(curso => curso.eixoCode === areaCourse);

    setCourseTechListFiltered(auxAreaCourse);
  }, [areaCourse, courseTechList]);


  useEffect(() => {
    const aux = stageList.filter(etapa =>
      renderStage(etapa.render, classRoom)
    );
    setStageListVisible(aux)

  }, [classRoom.aggregateStage,
  classRoom.curricularOrganization,
  classRoom.typeServices])

  console.log(errors)

  useEffect(() => {
    if (errors) {
      const entries = Object.entries(errors).map(([key, error]) => ({
        id: key + '-' + error.message,
        fieldName: key,
        error,
      }));
      setMessageRequired(entries);
    }
  }, [errors]);

  return (
    <>
      {!removeLoading && <Loading />}
      <div className='span-message'>
        {messageRequired.map(({ id, fieldName, error }) => {
          const idx = getIndexByLabel(fieldName) || "";
          const text = error.message;

          return (
            <MessagePopUp
              key={id}
              title={`Campo ${idx} - obrigatório`}
              text={text}
              onClose={() =>
                setMessageRequired(prev => prev.filter(m => m.id !== id))
              }
            />
          );
        })}
      </div>
      <App>
        <Container>
          <InfoForm
            title="Turma"
            wasChanged={classRoom.wasChanged}
            subtitle="Caracterização"
            positionPagination="1/1"
          />
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormContent>
              <InputResponsive1
                title={getTitleIndex('Nome da turma', 'name')}
                name='name'
                mandatory='*'
                value={!classRoom.name?.length === 0 ? '' : classRoom.name}
                {...register('name')}
                {...setValue('name', classRoom.name ?? -1)}
                onChange={e => setClassRoom({ ...classRoom, name: e.target.value.toUpperCase() })}
                erro={errors.name?.message}
              />
              <Box >
                <TitleFieldForm>
                  {getTitleIndex('Tipo de mediação didático-pedagógica', 'typeMediation')}<Madatory>*</Madatory>
                </TitleFieldForm>
                <Select
                  name='typeMediation'
                  defaultValue={!classRoom.typeMediation ? 0 : classRoom.typeMediation}
                  {...register('typeMediation')}
                  onChange={e => {
                    setClassRoom({ ...classRoom, typeMediation: Number(e.target.value) });
                    setValue('typeMediation', Number(e.target.value))
                  }}>
                  <Option value={0} disabled hidden>Selecione</Option>
                  <Option value={1} >Presencial</Option>
                  <Option value={2}>Semipresencial</Option>
                  <Option value={3}>Educação a distância (EAD)</Option>
                </Select>
                <Message>{errors.typeMediation?.message}</Message>
              </Box>

              <Box style={{ display: classRoom.typeMediation === 1 ? 'flex' : 'none' }}>
                <TitleFieldForm> {getTitleIndex('Horários de funcionamento (horário inicial - Horário Final)', 'daysWeek', classRoom.typeMediation === 1)}<Madatory>*</Madatory> </TitleFieldForm>
                <Message>{errors.daysWeek?.message}</Message>
                <InputResponsive1
                  title='Domingo'
                  placeholder='00:00-00:00'
                  name='Domingo'
                  value={!classRoom.daysWeek.monday === 0 ? '' : classRoom.daysWeek.sunday}
                  {...register('daysWeek.sunday')}
                  onChange={e => {
                    setClassRoom({
                      ...classRoom,
                      daysWeek: {
                        ...classRoom.daysWeek,
                        sunday: maskHour(e.target.value)
                      }
                    });
                    setValue('daysWeek.sunday', maskHour(e.target.value), { shouldValidate: true })
                  }}
                />
                <InputResponsive1
                  title='Segunda-feira'
                  name='segunda'
                  placeholder='00:00-00:00'
                  value={!classRoom.daysWeek.monday === 0 ? '' : classRoom.daysWeek.monday}
                  {...register('daysWeek.monday')}
                  {...setValue('daysWeek.monday', classRoom.daysWeek.monday)}
                  onChange={e =>
                    setClassRoom({
                      ...classRoom,
                      daysWeek: {
                        ...classRoom.daysWeek,
                        monday: maskHour(e.target.value)
                      }
                    })}
                />
                <InputResponsive1
                  title='Terça-feira'
                  name='terça'
                  placeholder='00:00-00:00'

                  value={!classRoom.daysWeek.tuesday === null ? '' : classRoom.daysWeek.tuesday}
                  {...register('daysWeek.tuesday')}
                  {...setValue('daysWeek.tuesday', classRoom.daysWeek.tuesday)}
                  onChange={e =>
                    setClassRoom({
                      ...classRoom,
                      daysWeek: {
                        ...classRoom.daysWeek,
                        tuesday: maskHour(e.target.value)
                      }
                    })}
                />
                <InputResponsive1
                  title='Quarta-feira'
                  name='quarta'
                  placeholder='00:00-00:00'

                  value={!classRoom.daysWeek.wednesday === 0 ? '' : classRoom.daysWeek.wednesday}
                  {...register('daysWeek.wednesday')}
                  {...setValue('daysWeek.wednesday', classRoom.daysWeek.wednesday)}
                  onChange={e =>
                    setClassRoom({
                      ...classRoom,
                      daysWeek: {
                        ...classRoom.daysWeek,
                        wednesday: maskHour(e.target.value)
                      }
                    })}
                />
                <InputResponsive1
                  title='Quinta-feira'
                  name='quinta'
                  placeholder='00:00-00:00'

                  value={!classRoom.daysWeek.thursday === 0 ? '' : classRoom.daysWeek.thursday}
                  {...register('daysWeek.thursday')}
                  {...setValue('daysWeek.thursday', classRoom.daysWeek.thursday)}
                  onChange={e =>
                    setClassRoom({
                      ...classRoom,
                      daysWeek: {
                        ...classRoom.daysWeek,
                        thursday: maskHour(e.target.value)
                      }
                    })}
                />
                <InputResponsive1
                  title='Sexta-feira'
                  name='sexta'
                  placeholder='00:00-00:00'
                  value={!classRoom.daysWeek.friday === 0 ? '' : classRoom.daysWeek.friday}
                  {...register('daysWeek.friday')}
                  {...setValue('daysWeek.friday', classRoom.daysWeek.friday)}
                  onChange={e =>
                    setClassRoom({
                      ...classRoom,
                      daysWeek: {
                        ...classRoom.daysWeek,
                        friday: maskHour(e.target.value)
                      }
                    })}
                />
                <InputResponsive1
                  title='Sábado'
                  name='sabado'
                  placeholder='00:00-00:00'

                  value={!classRoom.daysWeek.saturday === 0 ? '' : classRoom.daysWeek.saturday}
                  {...register('daysWeek.saturday')}
                  {...setValue('daysWeek.saturday', classRoom.daysWeek.saturday)}
                  onChange={e =>
                    setClassRoom({
                      ...classRoom,
                      daysWeek: {
                        ...classRoom.daysWeek,
                        saturday: maskHour(e.target.value)
                      }
                    })}
                />
              </Box>
              <Box>
                <TitleFieldForm>
                  {getTitleIndex('Tipo de turma', 'typeServices')}
                  <Madatory>*</Madatory>
                </TitleFieldForm>
                <Checkbox title='Curricular(etapa de ensino)'
                  name='typeServices.curricularStage'
                  {...register('typeServices.curricularStage')}
                  setValue={setValue('typeServices.curricularStage', classRoom.typeServices.curricularStage)}
                  checked={classRoom.typeServices.curricularStage !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, typeServices: {
                      ...classRoom.typeServices,
                      curricularStage: e.target.checked ? 1 : 0,
                    }
                  })} />
                <Checkbox title='Atividade Complementar'
                  name='typeServices.complementaryActivity'
                  {...register('typeServices.complementaryActivity')}
                  setValue={setValue('typeServices.complementaryActivity', classRoom.typeServices.complementaryActivity)}
                  disabled={classRoom.typeMediation === 1 ? false : true}
                  checked={classRoom.typeServices.complementaryActivity !== 1 || classRoom.typeServices.complementaryActivity === " " ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, typeServices: {
                      ...classRoom.typeServices,
                      complementaryActivity: e.target.checked ? 1 : 0,
                    }
                  })} />
                <Checkbox title='Atendimento educacional especializado (AEE)'
                  name='typeServices.specializedEducationalService'
                  {...register('typeServices.specializedEducationalService')}
                  setValue={setValue('typeServices.specializedEducationalService', classRoom.typeServices.specializedEducationalService)}
                  disabled={classRoom.typeMediation === 1 ? false : true}
                  checked={classRoom.typeServices.specializedEducationalService !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, typeServices: {
                      ...classRoom.typeServices,
                      specializedEducationalService: e.target.checked ? 1 : 0,
                    }
                  })} />
                <Message>{errors.typeServices?.message}</Message>
              </Box>
              <Box style={{ display: classRoom.typeServices.complementaryActivity === 1 ? 'block' : 'none' }}>
                <TitleFieldForm  >
                  {getTitleIndex('Atividades complementares', 'complementaryActivity', classRoom.typeServices.complementaryActivity === 1)}
                  <Madatory>*</Madatory>
                </TitleFieldForm>
                <Message>{errors.complementaryActivity?.message}</Message>
                <LabelSelect key={'dd'} >
                  Atividade 1<Madatory>*</Madatory>:
                </LabelSelect>
                <Select
                  name='complementaryActivity[0]'
                  value={classRoom.complementaryActivity?.code1 ?? 0}
                  {...register('complementaryActivity[0]')}
                  {...setValue('complementaryActivity[0]', classRoom.complementaryActivity?.code1 ?? 0)}
                  onChange={e => setClassRoom({
                    ...classRoom, complementaryActivity: {
                      ...classRoom.complementaryActivity,
                      code1: Number(e.target.value)
                    }
                  })}>
                  <Option key={Math.random() + 'eewe'} value={0} disabled hidden>Selecione</Option>
                  {complementaryActivityList.length > 0 ? complementaryActivityList.map((item, index) => {
                    return <Option key={Math.random() + item.code} value={item.code} >{item.activity}</Option>
                  }) : ''}
                </Select>
                <Box style={{ display: classRoom.complementaryActivity?.code1 > 0 ? 'flex' : 'none' }}>
                  <LabelSelect key={'dd'} >
                    Atividade 2:
                  </LabelSelect>
                  <Select
                    name='complementaryActivity[1]'
                    value={classRoom.complementaryActivity?.code2 ?? 0}
                    {...register('complementaryActivity[1]')}
                    {...setValue('complementaryActivity[1]', classRoom.complementaryActivity?.code2 ?? 0)}
                    onChange={e => setClassRoom({
                      ...classRoom, complementaryActivity: {
                        ...classRoom.complementaryActivity,
                        code2: Number(e.target.value)
                      }
                    })}>
                    <Option key={Math.random() + 'eewe'} value={0} disabled hidden>Selecione</Option>
                    {complementaryActivityList.length > 0 ? complementaryActivityList.map((item, index) => {
                      return <Option key={Math.random() + item.code} value={item.code} >{item.activity}</Option>
                    }) : ''}
                  </Select>
                </Box>
                <Box style={{ display: classRoom.complementaryActivity?.code2 > 0 ? 'flex' : 'none' }}>
                  <LabelSelect key={'dd'} >
                    Atividade 3:
                  </LabelSelect>
                  <Select
                    name='complementaryActivity[2]'
                    value={classRoom.complementaryActivity?.code3 ?? 0}
                    {...register('complementaryActivity[2]')}
                    {...setValue('complementaryActivity[2]', classRoom.complementaryActivity?.code3 ?? 0)}
                    onChange={e => setClassRoom({
                      ...classRoom, complementaryActivity: {
                        ...classRoom.complementaryActivity,
                        code3: Number(e.target.value)
                      }
                    })}>
                    <Option key={Math.random() + 'eewe'} value={0} disabled hidden>Selecione</Option>
                    {complementaryActivityList.length > 0 ? complementaryActivityList.map((item, index) => {
                      return <Option key={Math.random() + item.code} value={item.code} >{item.activity}</Option>
                    }) : ''}

                  </Select>
                </Box>
                <Box style={{ display: classRoom.complementaryActivity?.code3 > 0 ? 'flex' : 'none' }}>
                  <LabelSelect key={'dd'} >
                    Atividade 4:
                  </LabelSelect>
                  <Select
                    name='complementaryActivity[3]'
                    value={classRoom.complementaryActivity?.code4 ?? 0}
                    {...register('complementaryActivity[3]')}
                    {...setValue('complementaryActivity[3]', classRoom.complementaryActivity?.code4 ?? 0)}
                    onChange={e => setClassRoom({
                      ...classRoom, complementaryActivity: {
                        ...classRoom.complementaryActivity,
                        code4: Number(e.target.value)
                      }
                    })}>
                    <Option key={Math.random() + 'eewe'} value={0} disabled hidden>Selecione</Option>
                    {complementaryActivityList.length > 0 ? complementaryActivityList.map((item, index) => {
                      return <Option key={Math.random() + item.code} value={item.code} >{item.activity}</Option>
                    }) : ''}
                  </Select>
                </Box>
                <Box style={{ display: classRoom.complementaryActivity?.code4 > 0 ? 'flex' : 'none' }}>
                  <LabelSelect key={'dd'} >
                    Atividade 5:
                  </LabelSelect>
                  <Select
                    name='complementaryActivity[4]'
                    value={classRoom.complementaryActivity?.code5 ?? 0}
                    {...register('complementaryActivity[4]')}
                    {...setValue('complementaryActivity[4]', classRoom.complementaryActivity?.code5 ?? 0)}
                    onChange={e => setClassRoom({
                      ...classRoom, complementaryActivity: {
                        ...classRoom.complementaryActivity,
                        code5: Number(e.target.value)
                      }
                    })}>
                    <Option key={Math.random() + 'eewe'} value={0} disabled hidden>Selecione</Option>
                    {complementaryActivityList.length > 0 ? complementaryActivityList.map((item, index) => {
                      return <Option key={Math.random() + item.code} value={item.code} >{item.activity}</Option>
                    }) : ''}
                  </Select>
                </Box>
                <Box style={{ display: classRoom.complementaryActivity?.code5 > 0 ? 'flex' : 'none' }}>
                  <LabelSelect key={'dd'} >
                    Atividade 6:
                  </LabelSelect>
                  <Select
                    name='complementaryActivity[5]'
                    value={classRoom.complementaryActivity?.code6 ?? 0}
                    {...register('complementaryActivity[5]')}
                    {...setValue('complementaryActivity[5]', classRoom.complementaryActivity?.code6 ?? 0)}
                    onChange={e => setClassRoom({
                      ...classRoom, complementaryActivity: {
                        ...classRoom.complementaryActivity,
                        code6: Number(e.target.value)
                      }
                    })}>
                    <Option key={Math.random() + 'eewe'} value={0} disabled hidden>Selecione</Option>
                    {complementaryActivityList.length > 0 ? complementaryActivityList.map((item, index) => {
                      return <Option key={Math.random() + item.code} value={item.code} >{item.activity}</Option>
                    }) : ''}
                  </Select>
                </Box>
              </Box>
              <Box style={{ display: classRoom.typeServices.curricularStage === 1 ? 'flex' : 'none' }}>
                <TitleFieldForm>
                  {getTitleIndex('Turma de Educação Especial (classe especial)', 'specialEducationClass', classRoom.typeServices.curricularStage === 1)}
                  <Madatory>*</Madatory>
                </TitleFieldForm>
                <Select
                  name='specialEducationClass'
                  {...register('specialEducationClass')}
                  {...setValue('specialEducationClass', classRoom.specialEducationClass) ?? -1}
                  defaultValue={classRoom.specialEducationClass ?? -1}

                  onChange={e => setClassRoom({
                    ...classRoom, specialEducationClass: Number(e.target.value)
                  })}>
                  <Option value={-1}> Selecione</Option>
                  <Option value={0}>Não</Option>
                  <Option value={1}>Sim</Option>

                </Select>
                <Message>{errors.specialEducationClass?.message}</Message>
              </Box>
              <Box style={{ display: [1, 2].includes(classRoom.typeMediation) ? 'flex' : 'none' }}>
                <TitleFieldForm>
                  {getTitleIndex('Local de funcionamento diferenciado da turma', 'workingPlace', [1, 2].includes(classRoom.typeMediation))}
                  <Madatory>*</Madatory>
                </TitleFieldForm>
                <Select
                  name='workingPlace'
                  {...register('workingPlace')}
                  {...setValue('workingPlace', classRoom.workingPlace ?? -1)}
                  value={classRoom.workingPlace ?? -1}
                  onChange={e => setClassRoom({ ...classRoom, workingPlace: Number(e.target.value) })}>
                  <Option value={-1} disabled hidden>Selecione</Option>
                  <Option value={1}>Sala anexa</Option>
                  <Option value={2}>Unidade de atendimento socioeducativa</Option>
                  <Option value={3}>Unidade prisional</Option>
                  <Option value={0}>A turma não está em local de funcionamento diferenciado</Option>
                </Select>
                <Message>{errors.workingPlace?.message}</Message>
              </Box>
              {/* */}

              <Box style={{ display: classRoom.typeServices.curricularStage === 1 ? 'flex' : 'none' }}>
                <TitleFieldForm >
                  {getTitleIndex('Etapa agregada', 'aggregateStage', classRoom.typeServices.curricularStage === 1)} <Madatory>*</Madatory></TitleFieldForm>

                <Select
                  name='aggregateStage'
                  {...register('aggregateStage')}
                  {...setValue('aggregateStage', classRoom.aggregateStage ?? 0)}
                  defaultValue={classRoom.aggregateStage ?? 0}
                  onChange={e => setClassRoom({
                    ...classRoom,
                    aggregateStage: Number(e.target.value),
                    stage: 0,
                    multi: 0,
                  })}>
                  <Option value={0}> Selecione</Option>
                  {aggregtateList.map((item, index) => {
                    return <Option key={'AS' + item.code} value={item.code} >{item.label}</Option>
                  }
                  )}
                </Select>
                <Message>{errors.aggregateStage?.message}</Message>
              </Box>
              <Box style={{ display: [303, 305].includes(classRoom.aggregateStage) ? 'flex' : 'none' }}>
                <TitleFieldForm>
                  {getTitleIndex('Organização curricular da turma', 'curricularOrganization', [303, 305].includes(classRoom.aggregateStage))}
                  <Madatory>*</Madatory>
                </TitleFieldForm>
                <Message>{errors.curricularOrganization?.message}</Message>
                <Checkbox title='Formação geral básica'
                  name='curricularOrganization.basicGeneralFormation'
                  register={register('curricularOrganization.basicGeneralFormation')}
                  setValue={setValue('curricularOrganization.basicGeneralFormation', classRoom.curricularOrganization?.basicGeneralFormation ?? 0)}
                  checked={classRoom.curricularOrganization?.basicGeneralFormation !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, curricularOrganization: {
                      ...classRoom.curricularOrganization,
                      basicGeneralFormation: e.target.checked ? 1 : 0

                    }
                  })} />
                <Checkbox title='Itinerário formativo de aprofundamento'
                  name='curricularOrganization.deepFormativeItinerary'
                  register={register('curricularOrganization.deepFormativeItinerary')}
                  setValue={setValue('curricularOrganization.deepFormativeItinerary', classRoom.curricularOrganization?.deepFormativeItinerary ?? 0)}
                  checked={classRoom.curricularOrganization?.deepFormativeItinerary !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, curricularOrganization: {
                      ...classRoom.curricularOrganization,
                      deepFormativeItinerary: e.target.checked ? 1 : 0

                    }
                  })} />
                <Checkbox title='Itinerário de formação técnica e profissional'
                  name='curricularOrganization.technicalProfessionalItinerary'
                  register={register('curricularOrganization.technicalProfessionalItinerary]')}
                  setValue={setValue('curricularOrganization.technicalProfessionalItinerary', classRoom.curricularOrganization?.professionalFormativeItinerary ?? 0)}
                  checked={classRoom.curricularOrganization?.professionalFormativeItinerary !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, curricularOrganization: {
                      ...classRoom.curricularOrganization,
                      professionalFormativeItinerary: e.target.checked ? 1 : 0
                    }
                  })} />
              </Box>
              <Box style={{ display: classRoom.curricularOrganization?.deepFormativeItinerary === 1 ? 'flex' : 'none' }} >
                <TitleFieldForm>
                  {getTitleIndex('Área(s) do itinerário formativo', 'formativeArea', classRoom.curricularOrganization?.deepFormativeItinerary === 1)}
                  <Madatory>*</Madatory>
                </TitleFieldForm>
                <Message>{errors.formativeArea?.message}</Message>
                <Checkbox title='Matemática e suas tecnologias'
                  name='formativeArea[0]'
                  register={register('formativeArea[0]')}
                  setValue={setValue('formativeArea[0]', classRoom.formativeArea.formativeArea)}
                  checked={classRoom.formativeArea.formativeArea !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, formativeArea: {
                      ...classRoom.formativeArea,
                      formativeArea: e.target.checked ? 1 : 0

                    }
                  })} />
                <Checkbox title='Ciências da natureza e suas tecnologias'
                  name='formativeArea[1]'
                  register={register('formativeArea[1]')}
                  setValue={setValue('formativeArea[1]', classRoom.formativeArea.scienceTechnologies)}
                  checked={classRoom.formativeArea.scienceTechnologies !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, formativeArea: {
                      ...classRoom.formativeArea,
                      scienceTechnologies: e.target.checked ? 1 : 0

                    }
                  })} />
                <Checkbox title='Ciências humanas e sociais aplicadas'
                  name='formativeArea[2]'
                  register={register('formativeArea[2]')}
                  setValue={setValue('formativeArea[2]', classRoom.formativeArea.humanScience)}
                  checked={classRoom.formativeArea.humanScience !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, formativeArea: {
                      ...classRoom.formativeArea,
                      humanScience: e.target.checked ? 1 : 0
                    }
                  })} />
              </Box>
              <Box style={{
                display: ([301, 302, 303, 306, 308].includes(classRoom.aggregateStage)
                  && classRoom.typeServices.curricularStage === 1) ? 'flex' : 'none'
              }}>
                <TitleFieldForm >
                  {getTitleIndex('Etapa', 'stage', [301, 302, 303, 306, 308].includes(classRoom.aggregateStage))} <Madatory>*</Madatory>

                </TitleFieldForm>
                <Select
                  name='stage'
                  {...register('stage')}
                  {...setValue('stage', classRoom.stage)}
                  onChange={e => setClassRoom({
                    ...classRoom,
                    stage: Number(e.target.value),
                    multi: 0,
                    curricularComponents: resetValues(classRoom.curricularComponents)
                  })}
                >
                  <Option value={0} disabled hidden>Selecione</Option>
                  {stageListVisible?.map((item) => {
                    return <Option key={'stage' + item.code} value={item.code} >{item.label}</Option>
                  })}
                </Select>

                <Message>{errors.stage?.message}</Message>

                <Box style={{ display: [39, 40, 64].includes(classRoom.stage) ? 'flex' : 'none' }}>
                  <TitleFieldForm >
                    Área do curso</TitleFieldForm>
                  <Select
                    value={areaCourse}
                    onChange={e => setAreaCourse(Number(e.target.value))}>
                    <Option value={0}> Selecione</Option>
                    {areaCourseTeachList.map((item) => {
                      return <Option key={'course' + item.code} value={item.code} >{item.name}</Option>
                    })}
                  </Select>
                  <TitleFieldForm>
                    {getTitleIndex('Código do curso', 'codeCourse', [39, 40, 64].includes(classRoom.stage))}</TitleFieldForm>
                  <Select
                    name='codeCourse'
                    {...register('codeCourse')}
                    {...setValue('codeCourse', classRoom.codeCourse)}
                    defaultValue={classRoom.codeCourse}
                    onChange={e => setClassRoom({
                      ...classRoom, codeCourse: Number(e.target.value)
                    })}>
                    <Option value={0}> Selecione</Option>
                    {courseTechListFiltered.map((item) => {
                      return <Option key={'course' + item.code} value={item.code} >{item.name}</Option>
                    })}
                  </Select>
                  <Message>{errors.codeCourse?.message}</Message>
                </Box>
                <Box style={{ display: (classRoom.stage === 3 || classRoom.stage === 22 || classRoom.stage === 23 || classRoom.stage === 72 || classRoom.stage === 56 || classRoom.stage === 64) ? 'block' : 'none' }}>
                  <TitleFieldForm >
                    {getTitleIndex('turma Multi etapa', 'multi', (classRoom.stage === 3 || classRoom.stage === 22 || classRoom.stage === 23 || classRoom.stage === 72 || classRoom.stage === 56 || classRoom.stage === 64))}
                    <Madatory>*</Madatory>
                  </TitleFieldForm>
                  <Select
                    name='multi'
                    value={classRoom.multi ?? 0}
                    {...register('multi')}
                    {...setValue('multi', classRoom.multi)}
                    onChange={e => setClassRoom({ ...classRoom, multi: Number(e.target.value) })}>
                    <Option value={0} disabled hidden>Selecione</Option>
                    {renderSelectMulti(classRoom.stage).map(opcao =>
                    (
                      <option key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </option>
                    )
                    )}
                  </Select>
                </Box>
                <Message>{errors.multi?.message}</Message>
              </Box>
              <Box style={{ display: classRoom.stage > 3 ? 'flex' : 'none' }}>
                <TitleFieldForm>
                  {getTitleIndex('Formas de organização da turma', 'formsOrganization', classRoom.stage > 3)}
                  <Madatory>*</Madatory>
                </TitleFieldForm>
                <Message>{errors.formsOrganization?.message}</Message>
                <Checkbox title='Série/Ano (séries anuais)'
                  disabled={![14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 41, 25, 26, 27, 28, 29, 35, 36, 37, 38, 39, 40, 64, 56, 69, 70, 71, 72].includes(classRoom.stage)}
                  name='formsOrganization[0]'
                  register={register('formsOrganization[0]')}
                  setValue={setValue('formsOrganization[0]', classRoom.formsOrganization.seriesYear)}
                  checked={classRoom.formsOrganization.seriesYear !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, formsOrganization: {
                      ...classRoom.formsOrganization,
                      seriesYear: e.target.checked ? 1 : 0
                    }
                  })} />
                <Checkbox title='Periodo semestrais'
                  disabled={![25, 26, 27, 28, 29, 35, 36, 37, 38, 39, 40, 64, 69, 70, 71, 72].includes(classRoom.stage)}
                  name='formsOrganization[1]'
                  register={register('formsOrganization[1]')}
                  setValue={setValue('formsOrganization[1]', classRoom.formsOrganization.semesterPeriods)}
                  checked={classRoom.formsOrganization.semesterPeriods !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, formsOrganization: {
                      ...classRoom.formsOrganization,
                      semesterPeriods: e.target.checked ? 1 : 0

                    }
                  })} />
                <Checkbox title='Ciclo(s)'
                  name='formsOrganization[2]'
                  disabled={![14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 41, 56, 25, 26, 27, 28, 29, 35, 36, 37, 38].includes(classRoom.stage)}
                  register={register('formsOrganization[2]')}
                  setValue={setValue('formsOrganization[2]', classRoom.formsOrganization.cycles)}
                  checked={classRoom.formsOrganization.cycles !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, formsOrganization: {
                      ...classRoom.formsOrganization,
                      cycles: e.target.checked ? 1 : 0
                    }
                  })} />
                <Checkbox title='Grupo não seriados com base na idade ou competencia (art. 23 LDB)'
                  disabled={![14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 41, 25, 26, 27, 28, 29, 35, 36, 37, 38, 39, 40, 64, 56, 69, 70, 71, 72].includes(classRoom.stage)}
                  name='formsOrganization[3]'
                  register={register('formsOrganization[3]')}
                  setValue={setValue('formsOrganization[3]', classRoom.formsOrganization.noSerialGroup)}
                  checked={classRoom.formsOrganization.noSerialGroup !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, formsOrganization: {
                      ...classRoom.formsOrganization,
                      noSerialGroup: e.target.checked ? 1 : 0
                    }
                  })} />
                <Checkbox title='Módulos'
                  disabled={![14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 41, 25, 26, 27, 28, 29, 35, 36, 37, 38, 39, 40, 64, 56, 69, 70, 71, 72.].includes(classRoom.stage)}
                  name='formsOrganization[4]'
                  register={register('formsOrganization[4]')}
                  setValue={setValue('formsOrganization[4]', classRoom.formsOrganization.modules ?? 0)}
                  checked={classRoom.formsOrganization.modules !== 1 ? false : true}
                  onChange={e => setClassRoom({
                    ...classRoom, formsOrganization: {
                      ...classRoom.formsOrganization,
                      modules: e.target.checked ? 1 : 0

                    }
                  })} />
              </Box>
              <Box>
                <TitleFieldForm>
                  {getTitleIndex('Turma de Formação por Alternância (proposta pedagógica de formação por alternância: tempo-escola e tempo-comunidade)', 'alternationFormation')}
                  <Madatory>*</Madatory>
                </TitleFieldForm>

                <Select
                  name='alternationFormation'
                  {...register('alternationFormation')}
                  {...setValue('alternationFormation', classRoom.alternationFormation ?? -1)}
                  defaultValue={classRoom.alternationFormation ?? -1}
                  onChange={e => setClassRoom({
                    ...classRoom, alternationFormation: Number(e.target.value)
                  })}>
                  <Option value={-1}> Selecione</Option>
                  <Option value={0}>Não</Option>
                  <Option value={1}>Sim</Option>

                </Select>
                <Message>{errors.alternationFormation?.message}</Message>
              </Box>

              <Box style={{ display: classRoom.curricularOrganization?.professionalFormativeItinerary === 1 ? 'flex' : 'none' }}>
                <TitleFieldForm>
                  {getTitleIndex('Tipo do curso do itinerário de formação técnica e profissional', 'typeCourseFormativeItinerary', classRoom.curricularOrganization?.professionalFormativeItinerary === 1)} </TitleFieldForm>
                <Select
                  name='typeCourseFormativeItinerary'
                  register={register('typeCourseFormativeItinerary')}
                  setValue={setValue('typeCourseFormativeItinerary', classRoom.typeCourseFormativeItinerary ?? -1)}
                  defaultValue={classRoom.typeCourseFormativeItinerary ?? -1}
                  onChange={e => setClassRoom({
                    ...classRoom,
                    ...classRoom.typeCourseFormativeItinerary = Number(e.target.value)
                  })}>
                  <Option value={-1}> Selecione</Option>
                  <Option value={1}>1 – Curso técnico</Option>
                  <Option value={2}>2 – Qualificação profissional técnica</Option>
                </Select>
                <Message>{errors.typeCourseFormativeItinerary?.message}</Message>
              </Box>
              <Box style={{ display: classRoom.typeCourseFormativeItinerary === 1 ? 'flex' : 'none' }}>
                <TextLabel >
                  Área do curso</TextLabel>
                <Select
                  value={areaCourse}
                  onChange={e => setAreaCourse(Number(e.target.value))}>
                  <Option value={0}> Selecione</Option>
                  {areaCourseTeachList.map((item) => {
                    return <Option key={'courseSC' + item.code} value={item.code} >{item.name}</Option>
                  })}
                </Select>
                <TextLabel>
                  {getTitleIndex('Código do curso técnico', 'courseTechCode', classRoom.typeCourseFormativeItinerary === 1)}</TextLabel>
                <Select
                  name='courseTechCode'
                  register={register('courseTechCode')}
                  setValue={setValue('courseTechCode', classRoom.courseTechCode ?? -1)}
                  defaultValue={classRoom.courseTechCode ?? -1}
                  style={{ display: classRoom.stage > 0 && classRoom.stage < 4 ? 'none' : 'flex' }}
                  onChange={e => setClassRoom({
                    ...classRoom, courseTechCode: Number(e.target.value)
                  })}>
                  <Option value={-1}> Selecione</Option>
                  {courseTechListFiltered.map((item) => {
                    return <Option key={'courseTechC' + item.code} value={item.code} >{item.name}</Option>
                  }
                  )}
                </Select>
                <Message>{errors.courseTechCode?.message}</Message>
              </Box>

              <Box
                style={{ display: Number(classRoom.stage) > 2 ? 'flex' : 'none' }}
              >
                <TitleFieldForm >
                  {getTitleIndex('Áreas do conhecimento/Componentes curriculares', 'curricularComponents', Number(classRoom.stage) > 2)}
                  <Madatory>*</Madatory>
                </TitleFieldForm>
                <Message>{errors.curricularComponents?.message}</Message>
                <FormContent>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >
                    Arte (Educação Artística, Teatro, Dança, Música, Artes Plásticas e outras)
                  </Label>
                  <Select
                    name='curricularComponents[0]'
                    register={register('curricularComponents[0]')}
                    setValue={setValue('curricularComponents[0]', classRoom.curricularComponents.art)}
                    checked={classRoom.curricularComponents.art !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.art = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 ? 'none' : 'flex' || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 }}
                  >Educação Física</Label>
                  <Select
                    name='curricularComponents[1]'
                    register={register('curricularComponents[1]')}
                    setValue={setValue('curricularComponents[1]', classRoom.curricularComponents.physicalEducation)}
                    checked={classRoom.curricularComponents.physicalEducation !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 ? 'none' : 'flex' || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.physicalEducation = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Libras</Label>
                  <Select
                    name='curricularComponents[2]'
                    register={register('curricularComponents[2]')}
                    setValue={setValue('curricularComponents[2]', classRoom.curricularComponents.librasCC)}
                    checked={classRoom.curricularComponents.librasCC !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.librasCC = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Língua /Literatura Portuguesa</Label>
                  <Select
                    name='curricularComponents[3]'
                    register={register('curricularComponents[3]')}
                    setValue={setValue('curricularComponents[3]', classRoom.curricularComponents.portugueseLanguage)}
                    checked={classRoom.curricularComponents.portugueseLanguage !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.portugueseLanguage = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Língua /Literatura estrangeira - Inglês</Label>
                  <Select
                    name='curricularComponents[4]'
                    register={register('curricularComponents[4]')}
                    setValue={setValue('curricularComponents[4]', classRoom.curricularComponents.englishLanguage)}
                    checked={classRoom.curricularComponents.englishLanguage !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.englishLanguage = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Língua /Literatura estrangeira - Francês</Label>
                  <Select
                    name='curricularComponents[5]'
                    register={register('curricularComponents[5]')}
                    setValue={setValue('curricularComponents[5]', classRoom.curricularComponents.frenchLanguageCC)}
                    checked={classRoom.curricularComponents.frenchLanguageCC !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.frenchLanguageCC = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Língua /Literatura estrangeira - Outra</Label>
                  <Select
                    name='curricularComponents[6]'
                    register={register('curricularComponents[6]')}
                    setValue={setValue('curricularComponents[6]', classRoom.curricularComponents.anotherForeignLanguage)}
                    checked={classRoom.curricularComponents.anotherForeignLanguage !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.anotherForeignLanguage = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Língua /Literatura estrangeira - Espanhol</Label>
                  <Select
                    name='curricularComponents[7]'
                    register={register('curricularComponents[7]')}
                    setValue={setValue('curricularComponents[7]', classRoom.curricularComponents.spanishLanguageCC)}
                    checked={classRoom.curricularComponents.spanishLanguageCC !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.spanishLanguageCC = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || (classRoom.stage < 14 && classRoom.stage > 18) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Matemática</Label>
                  <Select
                    name='curricularComponents[8]'
                    register={register('curricularComponents[8]')}
                    setValue={setValue('curricularComponents[8]', classRoom.curricularComponents.mathematics)}
                    checked={classRoom.curricularComponents.mathematics !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || (classRoom.stage < 14 && classRoom.stage > 18) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.mathematics = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>

                  <Label style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 18) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 69 ? 'none' : 'flex' }}
                  >Biologia</Label>
                  <Select
                    name='curricularComponents[9]'
                    register={register('curricularComponents[9]')}
                    setValue={setValue('curricularComponents[9]', classRoom.curricularComponents.biology)}
                    checked={classRoom.curricularComponents.biology !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 18) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 69 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.biology = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 25 && classRoom.stage <= 34) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 71 || classRoom.stage === 67 || classRoom.stage === 74 ? 'none' : 'flex' }}
                  >Ciências</Label>
                  <Select
                    name='curricularComponents[10]'
                    register={register('curricularComponents[10]')}
                    setValue={setValue('curricularComponents[10]', classRoom.curricularComponents.sciences)}
                    checked={classRoom.curricularComponents.sciences !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 25 && classRoom.stage <= 34) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 71 || classRoom.stage === 67 || classRoom.stage === 74 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.sciences = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 18) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 69 ? 'none' : 'flex' }}
                  >Física</Label>
                  <Select
                    name='curricularComponents[11]'
                    register={register('curricularComponents[11]')}
                    setValue={setValue('curricularComponents[11]', classRoom.curricularComponents.physical)}
                    checked={classRoom.curricularComponents.physical !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 18) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 69 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.physical = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 18) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 69 ? 'none' : 'flex' }}
                  >Química</Label>
                  <Select
                    name='curricularComponents[12]'
                    register={register('curricularComponents[12]')}
                    setValue={setValue('curricularComponents[12]', classRoom.curricularComponents.chemical)}
                    checked={classRoom.curricularComponents.chemical !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 18) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 69 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.chemical = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Filosofia</Label>
                  <Select
                    name='curricularComponents[13]'
                    register={register('curricularComponents[13]')}
                    setValue={setValue('curricularComponents[13]', classRoom.curricularComponents.philosophy)}
                    checked={classRoom.curricularComponents.philosophy !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.philosophy = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Geografia</Label>
                  <Select
                    name='curricularComponents[14]'
                    register={register('curricularComponents[14]')}
                    setValue={setValue('curricularComponents[14]', classRoom.curricularComponents.geography)}
                    checked={classRoom.curricularComponents.geography !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.geography = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >História</Label>
                  <Select
                    name='curricularComponents[15]'
                    setValue={setValue('curricularComponents[15]', classRoom.curricularComponents.history === 1 ? 1 : 0)}
                    register={register('curricularComponents[15]')}
                    checked={classRoom.curricularComponents.history !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.history = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 18) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 69 ? 'none' : 'flex' }}
                  >Sociologia</Label>
                  <Select
                    name='curricularComponents[21]'
                    register={register('curricularComponents[21]')}
                    setValue={setValue('curricularComponents[21]', classRoom.curricularComponents.sociology)}
                    checked={classRoom.curricularComponents.sociology !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 18) || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 69 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.sociology = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Ensino religioso</Label>
                  <Select
                    name='curricularComponents[18]'
                    register={register('curricularComponents[18]')}
                    setValue={setValue('curricularComponents[18]', classRoom.curricularComponents.religiousEducation)}
                    checked={classRoom.curricularComponents.religiousEducation !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.religiousEducation = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Informática/computação</Label>
                  <Select
                    name='curricularComponents[19]'
                    register={register('curricularComponents[19]')}
                    setValue={setValue('curricularComponents[19]', classRoom.curricularComponents.informaticsComputing)}
                    checked={classRoom.curricularComponents.informaticsComputing !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.informaticsComputing = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 23) || (classRoom.stage >= 25 && classRoom.stage <= 29) || (classRoom.stage >= 35 && classRoom.stage <= 38) || classRoom.stage === 41 || classRoom.stage === 56 || (classRoom.stage >= 70 && classRoom.stage <= 72) ? 'none' : 'flex' }}
                  >Áreas de conhecimentos profissionalizantes</Label>
                  <Select
                    name='curricularComponents[20]'
                    register={register('curricularComponents[20]')}
                    setValue={setValue('curricularComponents[20]', classRoom.curricularComponents.professionalKnowledgeAreas)}
                    checked={classRoom.curricularComponents.customKnowledgeAreas !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 23) || (classRoom.stage >= 25 && classRoom.stage <= 29) || (classRoom.stage >= 35 && classRoom.stage <= 38) || classRoom.stage === 41 || classRoom.stage === 56 || (classRoom.stage >= 70 && classRoom.stage <= 72) ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.customKnowledgeAreas = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 23) || (classRoom.stage >= 25 && classRoom.stage <= 34) || (classRoom.stage >= 39 && classRoom.stage <= 41) || classRoom.stage === 56 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 67 || (classRoom.stage >= 70 && classRoom.stage <= 74) ? 'none' : 'flex' }}
                  >Áreas de conhecimentos pedagógicas</Label>
                  <Select
                    name='curricularComponents[28]'
                    register={register('curricularComponents[28]')}
                    setValue={setValue('curricularComponents[28]', classRoom.curricularComponents.areasPedagogicalKnowledge)}
                    checked={classRoom.curricularComponents.areasPedagogicalKnowledge !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 23) || (classRoom.stage >= 25 && classRoom.stage <= 34) || (classRoom.stage >= 39 && classRoom.stage <= 41) || classRoom.stage === 56 || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 67 || (classRoom.stage >= 70 && classRoom.stage <= 74) ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.areasPedagogicalKnowledge = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Língua Indigena</Label>
                  <Select
                    name='curricularComponents[22]'
                    register={register('curricularComponents[22]')}
                    setValue={setValue('curricularComponents[22]', classRoom.curricularComponents.indigenousLanguageCC)}
                    checked={classRoom.curricularComponents.indigenousLanguageCC !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.indigenousLanguageCC = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 21) || (classRoom.stage >= 25 && classRoom.stage <= 41) || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 70 || classRoom.stage === 71 || classRoom.stage === 74 || classRoom.stage === 67 ? 'none' : 'flex' }}
                  >Estudos Sociais</Label>
                  <Select
                    name='curricularComponents[23]'
                    register={register('curricularComponents[23]')}
                    {...setValue('curricularComponents[23]', classRoom.curricularComponents.socialStudies)}
                    checked={classRoom.curricularComponents.socialStudies !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || (classRoom.stage >= 14 && classRoom.stage <= 21) || (classRoom.stage >= 25 && classRoom.stage <= 41) || classRoom.stage === 64 || classRoom.stage === 68 || classRoom.stage === 70 || classRoom.stage === 71 || classRoom.stage === 74 || classRoom.stage === 67 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.socialStudies = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Língua Portuguesa como segunda língua'</Label>
                  <Select
                    name='curricularComponents[24]'
                    register={register('curricularComponents[24]')}
                    setValue={setValue('curricularComponents[24]', classRoom.curricularComponents.portugueseSecondLanguage)}
                    checked={classRoom.curricularComponents.portugueseSecondLanguage !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.portugueseSecondLanguage = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 ? 'none' : 'flex' }}
                  >Estágio curricular supervisionado</Label>
                  <Select
                    name='curricularComponents[25]'
                    register={register('curricularComponents[25]')}
                    setValue={setValue('curricularComponents[25]', classRoom.curricularComponents.supervisedInternship)}
                    checked={classRoom.curricularComponents.supervisedInternship !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.supervisedInternship = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                  >Projeto de Vida</Label>
                  <Select
                    name='curricularComponents[26]'
                    register={register('curricularComponents[26]')}
                    setValue={setValue('curricularComponents[26]', classRoom.curricularComponents.lifeProjectCC)}
                    checked={classRoom.curricularComponents.lifeProjectCC !== 1 ? false : true}
                    style={{ display: classRoom.stage <= 3 || classRoom.stage === 39 || classRoom.stage === 40 || classRoom.stage === 64 || classRoom.stage === 68 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.lifeProjectCC = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>
                  <Label style={{ display: classRoom.stage > 0 && classRoom.stage < 4 ? 'none' : 'flex' }}>
                    Outras Áreas do conhecimento
                  </Label>
                  <Select
                    name='curricularComponents[27]'
                    {...register('curricularComponents[27]')}
                    {...setValue('curricularComponents[27]', classRoom.curricularComponents.otherAreasKnowledge ?? -1)}
                    defaultValue={classRoom.curricularComponents.otherAreasKnowledge ?? -1}
                    style={{ display: classRoom.stage > 0 && classRoom.stage < 4 ? 'none' : 'flex' }}
                    onChange={e => setClassRoom({
                      ...classRoom,
                      ...classRoom.curricularComponents.otherAreasKnowledge = Number(e.target.value)
                    })}>
                    <Option value={-1}> Selecione</Option>
                    <Option value={0}>0 – Não oferece a área do conhecimento/componente curricular.</Option>
                    <Option value={1}>1 – Sim, oferece a área do conhecimento/componente curricular com docente vinculado.</Option>
                    <Option value={2}>2 – Sim, oferece a área do conhecimento/componente curricular sem docente vinculado.</Option>

                  </Select>

                </FormContent>

              </Box>

              <Box >
                <TitleFieldForm>
                  {getTitleIndex('Turma de Educação Bilíngue de Surdos (classe bilíngue de surdos).', 'bilingualEducationClassDeaf')}
                  <Madatory>*</Madatory>
                </TitleFieldForm>
                <Select
                  name=''
                  {...register('bilingualEducationClassDeaf')}
                  {...setValue('bilingualEducationClassDeaf', classRoom.bilingualEducationClassDeaf ?? -1)}
                  value={classRoom.bilingualEducationClassDeaf ?? -1}
                  onChange={e => setClassRoom({ ...classRoom, bilingualEducationClassDeaf: Number(e.target.value) })}>
                  <Option value={-1} disabled hidden>Selecione</Option>
                  <Option value={0}>Não</Option>
                  <Option value={1}>Sim</Option>
                </Select>
                <Message>{errors.bilingualEducationClassDeaf?.message}</Message>
              </Box>
              <ButtonFormFooter
                textNext="Salvar"
                linkBack={"/turma/pesquisar"}
              />
            </FormContent>
          </form>
        </Container >
      </App >
    </>
  )

}
export default Cadastro;